import React from 'react';
const Writting = () => {
    return (
        <div>
            <section className="colorlib-experience" data-section="writing">
                <div className="colorlib-narrow-content">
                    <div className="row">
                        <div
                            className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box"
                            data-animate-effect="fadeInLeft">
                            <span className="heading-meta">highlights</span>
                            <h2 className="colorlib-heading animate-box">Writings</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="timeline-centered">
                                
                                <article
                                    className="timeline-entry animate-box"
                                    data-animate-effect="fadeInLeft"
                                >
                                    <div className="timeline-entry-inner">
                                        <div className="timeline-icon">
                                        </div>
                                        <div className="timeline-label">
                                            <h2>
                                                Medium article{' '}
                                                <span>May 2020</span>
                                            </h2>
                                            <a href="" target="_blank" rel="noreferrer noopener">
                                                {' '}
                                                <span>
                                                    How Taking On Competitions Has Boosted My Journey As Developer.
                                                </span>
                                            </a>
                                            <br />
                                            <br />
                                            <ul>
                                                <li>
                                                    This is an article i wrote to share my journey in the Competitions area and how it shaped me become a good developer and software engineer.
                                                    The article can be accessed via this link <a href="https://medium.com/@henrymutegeki117/how-taking-on-competitions-has-boosted-my-journey-as-developer-e029b810509f">https://medium.com/@henrymutegeki117/how-taking-on-competitions-has-boosted-my-journey-as-developer-e029b810509f</a>
                                                </li>
                                        
                                            </ul>
                                        </div>
                                    </div>
                                </article>
                                <article
                                    className="timeline-entry animate-box"
                                    data-animate-effect="fadeInLeft"
                                >
                                    <div className="timeline-entry-inner">
                                        <div className="timeline-icon">
                                        </div>
                                        <div className="timeline-label">
                                            <h2>
                                                Black In AI Submission 2019 (NeurIPS Conference){' '}
                                                <span>July 2019</span>
                                            </h2>
                                            <a href="http://wids.mak.ac.ug/wids/" target="_blank" rel="noreferrer noopener">
                                                {' '}
                                                <span>
                                                    Poster Submission For Concept, "E-Campaign strategy working for Uganda’s Politics through Machine Learning." 
                                                </span>
                                            </a>
                                            <br />
                                            <br />
                                            <ul>
                                                <li>
                                                    I was part of the team of three that submitted a poster for the concept mentioned above. The work presents a solution to conduct sentiment analysis  between social media and newspaper content with the aim of  helping politicians to identify which media platforms optimize outreach to voters. Initial results show that the same techniques can be applied to improve campaigns to other sectors outside the political space like in promoting health drives in Uganda.

                        </li>
                                                <li>
                                                    Our concept was accepted and presented at the 2019 NeurIPS conference in Canada.
                        </li>
                                            </ul>
                                        </div>
                                    </div>
                                </article>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};
export default Writting;
